<template>
  <div v-if="student">
    <ProfileContainer
      :name="`${student.firstName} ${student.lastName}`"
      :phone="student.phone"
      :email="student.email"
      :userId="student.userId"
      :progress="-3"
      :lastFlight="() => goToSelectedFlight(lastFlightSession)"
    >
      <div v-if="this.$route.params.id">
        <hilo-button styleType="back" />
      </div>
      <div class="basicCard">
        <div class="row">
          <div class="col-sm-1 text-center">
            <img
              id="profilePic"
              :src="profilePicPath"
              alt="Profile Picture"
              width="150"
              height="150"
            />
          </div>
          <div
            class="col-sm-3"
            style="display: flex; align-items: center; padding-left: 4em"
          >
            <div class="row">
              <div class="col-sm-12">
                <h1>{{ `${student.firstName} ${student.lastName}` }}</h1>
              </div>
              <div class="col-sm-12">
                <h5>
                  Instructor:
                  {{
                    studentClass?.activeInstructor?.user?.firstName ||
                    "Not Assigned"
                  }}
                  {{ studentClass?.activeInstructor?.user?.lastName || "" }}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-sm-5 align-self-center">
            <div class="row text-center" style="width: 100%">
              <div class="col-sm-12">
                <hilo-button
                  styleType="grey"
                  style="margin-right: 20px"
                  label="Logbook"
                  @click="goToLogbook"
                />
                <Documents :userId="student.userId" userType="Student" />
                <hilo-button
                  :styleType="student.flightHold ? 'red' : 'grey'"
                  style="margin-right: 20px"
                  label="Flight Hold"
                  @click="toggleFlightHold"
                  :disabled="!useLoginStore().isAdmin"
                />
                <hilo-button
                  styleType="green"
                  :label="`Balance ${formatCurrency(student.balance)}`"
                  @click="openSaleTransactionModal"
                  :disabled="!useLoginStore().isAdmin"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2"></div>
          <div class="col-sm-1 align-items-center">
            <img
              :src="rightLogoPath"
              alt="Profile Picture"
              width="100"
              height="100"
            />
          </div>
        </div>
      </div>
      <div class="basicCard">
        <div class="row">
          <!--          <div class="col-sm-8 align-items-center">
            <div class="customCard align-items-center">
              <div>
                <div class="row">
                  <div class="col-sm-6 text-center hashTag">#VentureWest</div>
                </div>
                <h1 style="padding: 0.25em 0">Pilot Static System</h1>
                <h4>This Weeks Recommended Training</h4>
                <h4>
                  Review For {{ `${student.firstName} ${student.lastName}` }}
                </h4>
                <button class="arrowBtn" @click="goToStaticSystem">
                  &#8599;
                </button>
              </div>
            </div>
          </div>-->
          <div v-if="studentClass?.program" class="col-sm-4">
            <div class="customCard">
              <div class="row">
                <div class="col-sm-8">
                  <h5 class="cardTitles">Current Program</h5>
                  <h1>
                    {{ studentClass.program.name }}
                  </h1>
                  <div style="padding-bottom: 20px">
                    Start Date:
                    {{ studentClass.startDate }} | End Date:
                    {{ studentClass.endDate }}
                  </div>
                </div>
                <div class="col-sm-4 text-center">
                  <!--                  <hilo-button
                    styleType="grey"
                    label="View Trainings"
                    @click="goToTrainings"
                  />-->
                  <!--                  <h5 class="daysLeft">{{ calculateDaysLeft() }} Days Left</h5>-->
                </div>
              </div>
              <!--              <div class="row" style="width: 100%; margin-left: 0">
                <div class="col-sm-12 progressHolder align-items-center">
                  <div class="row" style="width: 100%">
                    <div class="col-sm-10 progressBar" id="referenceDiv"></div>
                  </div>
                  <div class="numberHours">
                    {{ currentProgram.totalHours }} Hours
                  </div>
                </div>
              </div>
              <div class="completedHours text-center" id="targetDiv">
                <h5>{{ currentProgram.hoursCompleted }} Hours</h5>
                <h5>Completed</h5>
                <h2>▼</h2>
              </div>-->
            </div>
          </div>
          <div class="col-sm-4"></div>
        </div>
      </div>
      <!--      <div class="basicCard">
        <div class="row" style="margin: 0">
          <div
            class="col-sm-2"
            v-for="program of programs"
            v-bind:key="program.id"
            :class="program.class"
          >
            <h2>{{ program.name }}</h2>
          </div>
        </div>
      </div>-->
      <!--      <div class="basicCard">
        <div v-if="lastFlightSession" class="row">
          <div class="col-sm-4">
            <div class="customCard">
              <h5 class="cardTitles">Last Session</h5>
              <h1>{{ lastFlightSession.name }}</h1>
              <h5 class="cardTitles">
                {{ lastFlightSession.date.toLocaleDateString() }}
              </h5>
              <p>{{ lastFlightSession.description }}</p>
              <hilo-button
                styleType="grey"
                label="View Flight"
                @click="goToSelectedFlight(lastFlightSession)"
              />
            </div>
          </div>
          <div
            class="col-sm-4"
            v-for="session of nextFlightSessions"
            v-bind:key="session.id"
          >
            <div class="customCard">
              <h5 class="cardTitles">Upcoming Reservation</h5>
              <h1>{{ session.name }}</h1>
              <h5 class="cardTitles">
                {{ session.date.toLocaleDateString() }}
              </h5>
              <p>{{ session.description }}</p>
              <div class="row">
                <div class="col-sm-6">
                  <hilo-button
                    v-if="session.name !== 'None'"
                    styleType="grey"
                    label="View Flight"
                    @click="goToSelectedFlight(session)"
                  />
                  <hilo-button
                    v-else
                    styleType="grey"
                    label="Schedule Flight"
                    @click="goToSelectedFlight"
                  />
                </div>
                <div class="col-sm-6">
                  <hilo-button
                    v-if="session.dispatch"
                    styleType="grey"
                    label="Dispatch"
                    @click="goToDispatch(session)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <UpcomingSchedule :id="getId()" :idType="getIdType()" />
      <!--      <div class="basicCard">
        <div class="customCard">
          <div class="row">
            <div class="col-sm-8">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h5 class="cardTitles">Venture West</h5>
                  <h1>Hilo AI Reporting</h1>
                  <h5 class="cardTitles">Post Flight Report</h5>
                </div>
                <hilo-button
                  styleType="grey"
                  label="View Full Report"
                  @click="goToFullReport"
                />
              </div>
              <div class="reportParagraph">
                {{ postFlightReport.report }}
              </div>
            </div>
            <div class="col-sm-4">
              <img
                :src="postFlightReport.imgUrl"
                alt="Report Image"
                class="reportImg"
              />
            </div>
          </div>
        </div>
      </div>-->
    </ProfileContainer>
    <b-modal
      ref="sale-transaction-modal"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      title="Sale Transaction"
    >
      <sale-transaction-modal
        ref="saleTransactionModalInstance"
        :student="student"
        @add-edit-item="showAddEditItemModal"
      ></sale-transaction-modal>
    </b-modal>

    <b-modal
      ref="add-edit-item-modal"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      :title="currentBillingItem ? 'Edit Billing Item' : 'Add Billing Item'"
      modal-class="add-top-margin"
    >
      <add-edit-billing-item-modal
        :item="currentBillingItem"
        @save="handleSaveBillingItem"
        @close="hideAddEditItemModal"
      />
    </b-modal>
  </div>
</template>
<script>
import ProfileContainer from "@/components/HiloComponents/ProfileContainer.vue";
import HiloButton from "@/components/HiloComponents/HiloButton.vue";
import Documents from "@/components/HiloComponents/Documents.vue";
import UpcomingSchedule from "@/components/HiloComponents/UpcomingScheduleOld.vue";
import { useLoginStore } from "@/stores/loginStore";
import ActiveStudentsAPIService from "@/servicehandlers/ActiveStudentsAPIService.js";
const activeStudentsAPIService = new ActiveStudentsAPIService();
import ClassesAPIService from "../../../servicehandlers/ClassesAPIService";
import { formatCurrency } from "@/util/currency";
import AddEditBillingItemModal from "@/pages/Dashboard/HiloPages/Schedule/AddEditBillingItemModal.vue";
import SaleTransactionModal from "@/pages/Dashboard/HiloPages/Schedule/SaleTransactionModal.vue";
import dayjs from "dayjs";
const classesAPIService = new ClassesAPIService();

export default {
  components: {
    SaleTransactionModal,
    AddEditBillingItemModal,
    UpcomingSchedule,
    Documents,
    HiloButton,
    ProfileContainer,
  },
  data() {
    return {
      user: null,
      student: null,
      instructor: null,
      profilePicPath: null,
      rightLogoPath: null,
      currentProgram: null,
      flightSessions: [],
      lastFlightSession: null,
      nextFlightSessions: [],
      upcomingSchedule: [],
      postFlightReport: null,
      programs: [],
      studentClass: null,
      currentBillingItem: null,
    };
  },
  async mounted() {
    this.user = useLoginStore().getUser;
    this.getClassData();
    //this.getProgram();
    //this.getPostFlightReport();
    //this.getPrograms();
    await this.getStudent();
    //this.getFlightSessions();
    this.$nextTick(() => {
      this.getDynamicWidth();
    });
    window.onload = this.getDynamicWidth;
    window.onresize = this.getDynamicWidth;
  },
  methods: {
    formatCurrency,
    useLoginStore,
    async getStudent() {
      let response;
      try {
        if (this.$route.params.id) {
          response = await activeStudentsAPIService.getStudentById(
            this.$route.params.id,
          );
        } else {
          response = await activeStudentsAPIService.getStudentByUserId(
            this.user.id,
          );
        }
        this.student = {
          ...response,
          lastName: response.user.lastName,
          firstName: response.user.firstName,
          email: response.user.email,
          phone: response.user.phone,
        };
      } catch (error) {}
      this.getProfilePic();
    },
    getId() {
      return this.$route.params.id ? this.$route.params.id : this.user.id;
    },
    getIdType() {
      return this.$route.params.id ? "activeStudentId" : "userId";
    },
    async getClassData() {
      let response;
      try {
        if (this.$route.params.id) {
          response = await classesAPIService.getByStudentActiveId(
            this.$route.params.id,
          );
        } else {
          response = await classesAPIService.getByStudentId(this.user.id);
        }
        this.studentClass = {
          ...response.class,
          startDate: response.class.startDate
            ? dayjs(response.class.startDate).format("MM/DD/YYYY")
            : "",
          endDate: response.class.endDate
            ? dayjs(response.class.endDate).format("MM/DD/YYYY")
            : "",
        };
      } catch (error) {}
    },
    getProfilePic() {
      const apiUrl = process.env.VUE_APP_API_URL;
      if (
        this.student.user.image &&
        typeof this.student.user.image === "string"
      ) {
        this.student.image = `${apiUrl}/file_uploads/${this.student.user.image.split("/").pop()}`;
      }
      this.profilePicPath =
        this.student.image || "/static/img/faces/face-0.jpg";
      this.rightLogoPath = "/static/img/v-w-private-logo.png";
    },
    openSaleTransactionModal() {
      this.$refs["sale-transaction-modal"].show();
    },
    showAddEditItemModal(item = null) {
      this.currentBillingItem = item;
      this.$refs["add-edit-item-modal"].show();
    },
    hideAddEditItemModal() {
      this.$refs["add-edit-item-modal"].hide();
    },
    handleSaveBillingItem(savedItem) {
      const saleTransactionModal = this.$refs.saleTransactionModalInstance;
      if (saleTransactionModal && saleTransactionModal.handleSaveBillingItem) {
        saleTransactionModal.handleSaveBillingItem(savedItem);
      }
      this.hideAddEditItemModal();
    },
    /*getProgram() {
      this.currentProgram = {
        id: 1,
        name: "Private",
        startDate: new Date("February 01, 2024 00:00:00"),
        endDate: new Date("July 13, 2024 00:00:00"),
        hoursCompleted: 45,
        totalHours: 70,
      };
    },
    getPrograms() {
      this.programs = [
        {
          id: 1,
          name: "Private",
          class: "",
        },
        {
          id: 2,
          name: "Instrument",
          class: "",
        },
        {
          id: 3,
          name: "Commercial",
          class: "",
        },
        {
          id: 4,
          name: "CFI",
          class: "",
        },
        {
          id: 5,
          name: "CFII",
          class: "",
        },
        {
          id: 6,
          name: "Multi",
          class: "",
        },
      ];
      let nextProgram = false;
      for (let program of this.programs) {
        if (this.programs.indexOf(program) === 0) {
          program.class = "firstProgram ";
        } else if (
          this.programs.indexOf(program) ===
          this.programs.length - 1
        ) {
          program.class = "lastProgram ";
        } else {
          program.class = "programCard ";
        }
        if (nextProgram) {
          program.class += "nextProgram";
          nextProgram = false;
        }
        if (program.id === this.studentClass.class.program.id) {
          nextProgram = true;
          for (let i = this.programs.indexOf(program); i >= 0; i--) {
            this.programs[i].class += "currentProgram";
          }
        }
      }
    },
    getFlightSessions() {
      this.flightSessions = [
        {
          id: 7,
          name: "Flight 7",
          date: new Date("03/28/24"),
          description:
            "Lorem ipsum dolor sit amet,\n" +
            "consectetuer adipiscing elit, sed diam\n" +
            "nonummy nibh euismod tincidunt ut\n" +
            "laoreet dolore ",
        },
        {
          id: 8,
          name: "Flight 8",
          date: new Date("05/01/24"),
          description:
            "Lorem ipsum dolor sit amet,\n" +
            "consectetuer adipiscing elit, sed diam\n" +
            "nonummy nibh euismod tincidunt ut\n" +
            "laoreet dolore ",
          dispatch: true,
        },
        {
          id: 9,
          name: "Flight 9",
          date: new Date("05/03/24"),
          description:
            "Lorem ipsum dolor sit amet,\n" +
            "consectetuer adipiscing elit, sed diam\n" +
            "nonummy nibh euismod tincidunt ut\n" +
            "laoreet dolore ",
          dispatch: false,
        },
      ];
      let next = false;
      let third = false;
      for (let session of this.flightSessions) {
        if (third) {
          this.nextFlightSessions.push(session);
          break;
        }
        if (next) {
          this.nextFlightSessions.push(session);
          third = true;
        }
        if (session.id === this.student.lastSessionId) {
          this.lastFlightSession = session;
          next = true;
        }
      }
      let nextId = this.student.lastSessionId;
      while (this.nextFlightSessions.length < 2) {
        let temp = {
          id: nextId++,
          name: "None",
          date: new Date("00/00/0000"),
          description: "No scheduled upcoming reservations",
          dispatch: false,
        };
        this.nextFlightSessions.push(temp);
      }
    },
    getPostFlightReport() {
      this.postFlightReport = {
        report:
          "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis",
        imgUrl: "/static/img/report.jpg",
      };
    },*/
    goToLogbook() {
      this.$router.push({ name: "Logbook" });
    },
    async toggleFlightHold() {
      const formData = {
        ...this.student,
        flightHold: !this.student.flightHold,
      };
      const userId = this.$route.params.id
        ? this.$route.params.id
        : this.user.id;
      await activeStudentsAPIService.update(userId, formData);
      await this.getStudent();
    },
    goToStaticSystem() {
      alert("Went to static system!");
    },
    goToTrainings() {
      alert("Went to Trainings!");
    },
    goToSelectedFlight(flight) {
      alert("Went to " + flight.name + " page!");
    },
    /*goToFullReport() {
      alert("Went to Full Report page!");
    },
    goToDispatch(session) {
      this.$router.push({
        name: "Dispatch",
        query: { session_id: session.id },
      });
    },*/
    calculateDaysLeft() {
      let mili = this.currentProgram.endDate - new Date();
      let sec = mili / 1000;
      let min = sec / 60;
      let hour = min / 60;
      return Math.floor(hour / 24);
    },
    getDynamicWidth() {
      const referenceDiv = document.getElementById("referenceDiv");
      const targetDiv = document.getElementById("targetDiv");
      const referenceWidth = referenceDiv.offsetWidth;

      targetDiv.style.left =
        55 +
        Math.round(
          (this.currentProgram.hoursCompleted /
            this.currentProgram.totalHours) *
            referenceWidth,
        ) +
        "px";
    },
  },
};
</script>
<style scoped>
h1,
h2,
h4,
h5,
h6 {
  margin: 0;
}

p {
  font-size: 12px;
  padding: 1em 1em;
}

h1,
h2 {
  font-weight: bold;
}

h5 {
  color: grey;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.basicCard {
  margin: 30px 20px 0 0;
  border-color: transparent;
}

#profilePic {
  padding: 0.25em;
  border-radius: 1em;
}

.cardTitles {
  padding: 0;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: black;
}

.align-items-center {
  display: flex;
  align-items: center;
}

.text-center {
  text-align: center;
}

.customCard {
  width: 100%;
  height: 100%;
  align-content: space-evenly;
  background-color: #f0f0f0;
  border-radius: 2em;
  padding: 1em 1.5em;
}

/*.hashTag {
  margin-left: 0.75em;
  clear: left;
  text-align: center;
  font-size: 16px;
  background-color: black;
  color: white;
  padding: 0;
  border-radius: 2em;
}

.arrowBtn {
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 28px;
  font-weight: lighter;
  bottom: 30px;
  right: 45px;
}

.arrowBtn:hover {
  transform: scale(1.05, 1.05);
}

.daysLeft {
  font-size: 16px;
  background-color: red;
  color: white;
  padding: 2px;
  margin-top: 30px;
}

.progressHolder {
  margin-top: 20px;
  background-color: #d0d0d0;
  border-radius: 2em;
  padding: 10px 30px;
  font-size: 10px;
  padding-right: 5px;
}

.progressBar {
  height: 20px;
  background-color: white;
  border-radius: 2em;
}

.numberHours {
  position: relative;
  margin: 0;
  font-size: 13px;
  width: 15%;
}

.completedHours {
  position: absolute;
  margin: 0;
  padding: 0;
  z-index: 10;
  bottom: 45px;
}*/

.completedHours h5 {
  color: black;
  margin: -10px;
  padding: 0;
}

.completedHours h2 {
  text-align: left;
  margin-top: -5px;
  transform: scale(1, 0.75);
}

/*.reportParagraph {
  height: auto;
  font-size: 19px;
  padding-top: 1.5em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 9;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reportImg {
  max-width: 100%;
  height: auto;
}

button {
  border-style: solid;
}

.programCard {
  display: flex;
  align-items: center;
  text-align: center;
  height: 50px;
  width: 100%;
  background-color: #f0f0f0;
  justify-content: center;
}

.firstProgram {
  display: flex;
  align-items: center;
  text-align: center;
  height: 50px;
  width: 100%;
  background-color: #f0f0f0;
  justify-content: center;
  border-radius: 3em 0 0 3em;
}

.lastProgram {
  display: flex;
  align-items: center;
  text-align: center;
  height: 50px;
  width: 100%;
  background-color: #f0f0f0;
  justify-content: center;
  border-radius: 0 3em 3em 0;
}

.lastProgram::after {
  background-color: white !important;
}

.nextProgram {
  background-color: black;
  color: white;
  border: black 1px solid;
  padding-left: 50px;
}

.nextProgram::after {
  content: "";
  position: absolute;
  left: 100%;
  top: 0;
  background-color: inherit;
  width: 30px;
  height: 50px;
  z-index: 10;
  clip-path: polygon(0 0, 100% 50%, 0 100%);
}

.nextProgram::before {
  content: "";
  position: absolute;
  left: -1px;
  top: -10px;
  background-color: white;
  width: 40px;
  height: 70px;
  z-index: 9;
  clip-path: polygon(0 0, 100% 50%, 0 100%);
}

.currentProgram {
  background-color: #59595b;
  color: white;
  border: #59595b 1px solid;
}

.currentProgram::after {
  content: "";
  position: absolute;
  left: 100%;
  top: 0;
  background-color: inherit;
  width: 30px;
  height: 50px;
  z-index: 10;
  clip-path: polygon(0 0, 100% 50%, 0 100%);
}*/
</style>

<style lang="css">
/*noinspection CssUnusedSymbol */
.add-top-margin {
  margin-top: 200px;
}
</style>
